import type { ColumnProps } from '#/common/components/DataGrid';

const columns: ColumnProps<Record<string, string>>[] = [
  // Mandatory columns
  {
    dataField: 'third_party_id',
    caption: 'Capital Need ID',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'title',
    caption: 'Title',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'asset',
    caption: 'Asset',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'type',
    caption: 'Type',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'cost',
    caption: 'Planned Cost',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'planned_date',
    caption: 'Planned Date',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'status',
    caption: 'Status',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },

  // Optional columns
  {
    dataField: 'description',
    caption: 'Description',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
];

export default columns;
